import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import styles from '../../styles';

const TotalSection = ({ items = [] }) => {
    // 1) Pre‑tax total: sum of (rate × qty)
    const amountBeforeTax = items.reduce(
        (sum, item) => sum + (item.rate * item.qty || 0),
        0
    );

    // 2) Total CGST and SGST amounts using the percentages from backend
    const totalCgst = items.reduce(
        (sum, item) =>
            sum + ((item.rate * item.qty || 0) * (item.cgst || 0)) / 100,
        0
    );
    const totalSgst = items.reduce(
        (sum, item) =>
            sum + ((item.rate * item.qty || 0) * (item.sgst || 0)) / 100,
        0
    );

    // 3) Grand total, round‑off, and final total
    const totalTax = totalCgst + totalSgst;
    const grandTotal = amountBeforeTax + totalTax;
    const roundOff = Math.round(grandTotal) - grandTotal;
    const finalTotal = Math.round(grandTotal);

    return (
        <View style={styles.totalSection}>
            <Text style={styles.totalText}>
                Amount Before Tax: {amountBeforeTax.toFixed(2)}
            </Text>
            <Text style={styles.totalText}>
                CGST Amount: {totalCgst.toFixed(2)}
            </Text>
            <Text style={styles.totalText}>
                SGST Amount: {totalSgst.toFixed(2)}
            </Text>
            <Text style={styles.totalText}>
                Round Off: {roundOff.toFixed(2)}
            </Text>
            <Text style={styles.totalText}>
                Total Amount: {finalTotal.toFixed(2)}
            </Text>
        </View>
    );
};

export default TotalSection;